import { APP_DOWNLOAD_ONELINK, getBaseUrl } from 'src/config/externalLinks';
import {
  BEACON_DELIVERY,
  logAnalyticsEvent,
} from 'src/modules/analytics/analytics';
import {
  SESSION_SCOPE,
  readStoredItem,
  writeStoredItem,
} from 'src/utils/storageManager';

const REFERRAL_CODE_PATTERN = /^[A-Za-z0-9-]{1,32}$/;
const MOBILE_USER_AGENT = /android|iphone|ipad|ipod/i;
const REFERRAL_REDIRECT_KEY = 'baobab_referral_store_redirect';

const isIpadPresentingAsMac = (): boolean =>
  /macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;

const isMobileBrowser = (): boolean =>
  MOBILE_USER_AGENT.test(navigator.userAgent) || isIpadPresentingAsMac();

export const getReferralCode = (
  params: URLSearchParams | string,
): string | null => {
  const code = new URLSearchParams(params).get('referral_code');
  return code && REFERRAL_CODE_PATTERN.test(code) ? code : null;
};

const REFERRAL_ONELINK_TEMPLATE = 'oldtw8ft';

const buildStoreLink = (referralCode: string): string => {
  const appUrl = encodeURIComponent(
    `${getBaseUrl()}?referral_code=${referralCode}`,
  );
  return `${APP_DOWNLOAD_ONELINK}/${REFERRAL_ONELINK_TEMPLATE}?deep_link_value=${appUrl}&af_web_dp=${appUrl}`;
};

export const getStoreLink = (referralCode: string | null): string =>
  referralCode && isMobileBrowser()
    ? buildStoreLink(referralCode)
    : APP_DOWNLOAD_ONELINK;

const claimRedirect = (referralCode: string): boolean => {
  const key = `${REFERRAL_REDIRECT_KEY}:${referralCode}`;
  if (readStoredItem(key, SESSION_SCOPE)) return false;
  return writeStoredItem(key, '1', SESSION_SCOPE);
};

let isRedirecting = false;

export const isRedirectingToStore = (): boolean => isRedirecting;

export const redirectReferralVisitToStore = (): void => {
  if (window.location.pathname !== '/') return;
  const referralCode = getReferralCode(window.location.search);
  if (!referralCode || !isMobileBrowser() || !claimRedirect(referralCode)) {
    return;
  }
  isRedirecting = true;
  void logAnalyticsEvent('referral_store_link_opened', {}, BEACON_DELIVERY);
  window.location.assign(buildStoreLink(referralCode));
};
